var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceChartDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 33,
    viewBox: "0 0 59 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8623 11.2902L58.5 16V31C58.5 32.1046 57.6046 33 56.5 33H2.5C1.39543 33 0.499996 32.1046 0.499996 31V6.5L9.45718 12.5545C10.5402 13.2866 12.0229 12.7999 12.4614 11.5683L14.5447 5.71634C14.5959 5.57259 14.6634 5.43516 14.7458 5.30675L16.5333 2.52194C17.3038 1.32163 19.0471 1.29053 19.8599 2.46259L23.5205 7.74111C23.6394 7.91264 23.7308 8.10175 23.7912 8.30155L25.2399 13.0889C25.7678 14.8334 28.1636 15.0202 28.9555 13.3786L31.5289 8.04422C31.9576 7.15564 32.9702 6.71239 33.9138 7.00024L38.1508 8.29269C38.5904 8.42679 38.9705 8.70822 39.2269 9.08962L42.378 13.7755C43.1244 14.8854 44.7288 14.9641 45.5802 13.9325L47.3623 11.7731C47.9723 11.034 49.0209 10.8314 49.8623 11.2902Z",
    fill: "url(#paint0_linear_1001_315879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 16L49.958 11.3019C49.1131 10.8372 48.0569 11.0416 47.4463 11.7879L45.7122 13.9073C44.8609 14.9478 43.2459 14.8689 42.5002 13.7503L39.3951 9.09268C39.1396 8.70935 38.7595 8.42601 38.3192 8.29052L34.1483 7.00718C33.2012 6.71575 32.1835 7.16185 31.7559 8.05583L29.2328 13.3313C28.444 14.9807 26.0383 14.7943 25.5129 13.0431L24.09 8.30014C24.0304 8.10126 23.9401 7.91288 23.8225 7.74178L20.2125 2.49094C19.4006 1.30996 17.6465 1.34115 16.8771 2.55025L15.1226 5.30729C15.0411 5.43535 14.9745 5.57227 14.924 5.7154L12.8651 11.5489C12.4281 12.7869 10.9371 13.2753 9.85243 12.5357L1 6.5",
    stroke: "#BC1919",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_315879",
    x1: 29.5,
    y1: 0,
    x2: 29.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7E7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceChartDown);
export default __webpack_public_path__ + "static/media/price-chart-down.8c5d3f4d6e994b8cd1d8ae085315a955.svg";
export { ForwardRef as ReactComponent };